module.exports = __webpack_public_path__ + "img/momo_home_bg_4.404c8963.png";